import { axiosRequestGET } from './serviceConfig';

export const getDashboardAccessService = (id) => axiosRequestGET(`/api/editor/roles/${id}/dashboard-access`);

export const getRolesAccessService = () => axiosRequestGET('/api/editor/roles');
